export class DialogModelBlockUser {
    constructor(
      public mobile: any
    ) {}
  }
  